@if (isOpen) {
  <div
    class="fixed inset-0 z-[99999] bg-black/60 flex items-center justify-center p-4"
    (click)="cancel()"
  >
    <div
      class="w-full max-w-6xl max-h-[90vh] flex flex-col rounded-2xl bg-white dark:bg-gray-900 shadow-2xl overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div>
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            Comenzar desde…
          </h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Elegí un punto de partida. Después podés editarlo libremente.
          </p>
        </div>
        <button type="button" (click)="cancel()"
          class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Grid de plantillas -->
      <div class="flex-1 overflow-y-auto p-6 bg-gray-50 dark:bg-gray-950/40">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          @for (tpl of templates; track trackById($index, tpl)) {
            <button
              type="button"
              (click)="pick(tpl)"
              (mouseenter)="hoveredId = tpl.id"
              (mouseleave)="hoveredId = null"
              class="group flex flex-col text-left rounded-2xl border-2 bg-white dark:bg-gray-900 overflow-hidden transition-all"
              [class.border-transparent]="hoveredId !== tpl.id"
              [class.border-blue-500]="hoveredId === tpl.id"
              [class.shadow-lg]="hoveredId === tpl.id"
            >
              <!-- Preview escalado en iframe -->
              <div class="relative h-56 overflow-hidden bg-gray-100 dark:bg-gray-800">
                <iframe
                  #previewFrame
                  class="absolute top-0 left-0 origin-top-left pointer-events-none"
                  style="width: 600px; height: 1200px; transform: scale(0.5); border: 0;"
                  scrolling="no"
                ></iframe>
                @if (hoveredId === tpl.id) {
                  <div class="absolute inset-0 flex items-center justify-center bg-blue-600/80 transition-opacity">
                    <span class="px-4 py-2 rounded-full bg-white text-blue-700 font-semibold text-sm shadow">
                      Usar esta plantilla
                    </span>
                  </div>
                }
              </div>

              <!-- Footer card -->
              <div class="p-4 border-t border-gray-100 dark:border-gray-800">
                <div class="flex items-center justify-between gap-2 mb-1">
                  <h3 class="text-sm font-semibold text-gray-900 dark:text-white truncate">
                    {{ tpl.name }}
                  </h3>
                  <span class="rounded-full px-2 py-0.5 text-[10px] font-medium flex-shrink-0"
                        [class]="categoryBadgeClass(tpl.category)">
                    {{ categoryLabel(tpl.category) }}
                  </span>
                </div>
                <p class="text-xs text-gray-500 dark:text-gray-400 line-clamp-2">
                  {{ tpl.description }}
                </p>
              </div>
            </button>
          }
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end gap-2 px-6 py-3 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
        <button (click)="cancel()" type="button"
          class="px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800">
          Cancelar
        </button>
      </div>
    </div>
  </div>
}
